import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { SettingsBillingPresenter } from "./presenter";
import { usePaymentCreditQuery } from "../../../payment-credit/repository";
import { useFetchTicketBasicListAvailable } from "../../repository";

type Props = {
	hotelID: string;
};

export const SettingsBillingContainer = ({ hotelID }: Props) => {
	const paymentCreditServerModel = usePaymentCreditQuery(hotelID);
	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);
	const { data: availableTicketList } = useFetchTicketBasicListAvailable({ hotelID });

	if (!paymentCreditServerModel || !hotelApplicationData || !availableTicketList) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<SettingsBillingPresenter
			hotelID={hotelID}
			paymentCreditServerModel={paymentCreditServerModel}
			hotelApplicationData={hotelApplicationData}
			availableTicketList={availableTicketList}
		/>
	);
};

SettingsBillingContainer.displayName = "SettingsBillingContainer";
